import { motion } from "framer-motion";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { MessageSquare, Image, Video, Music, Edit, Share2, FileText, Mic, PenTool, FileArchive, Globe } from "lucide-react";
import { toast } from "sonner";

interface Tool {
  title: string;
  description: string;
  icon: React.ReactNode;
  action: string;
  url?: string;
}

const tools: Tool[] = [
  {
    title: "Green Convert",
    description: "Converta e otimize seus arquivos com facilidade usando o Green Convert.",
    icon: <FileArchive className="h-8 w-8 text-primary" />,
    action: "Converter",
    url: "https://greenconvert.net/pt10/"
  },
  {
    title: "Criando Vídeo Meme",
    description: "Aprenda a criar vídeos meme divertidos usando o Clideo.",
    icon: <Video className="h-8 w-8 text-primary" />,
    action: "Aprender",
    url: "https://gokagen.blogspot.com/2025/04/criando-video-meme-no-clideo.html"
  },
  {
    title: "Sites de Séries Antigas",
    description: "Descubra os melhores sites para assistir séries antigas e nostálgicas.",
    icon: <Globe className="h-8 w-8 text-primary" />,
    action: "Explorar",
    url: "https://gokagen.blogspot.com/2025/04/meus-sites-de-series-antigas.html"
  },
  {
    title: "Vispunk Leonardo AI",
    description: "Crie imagens impressionantes com inteligência artificial usando a plataforma Leonardo AI.",
    icon: <Image className="h-8 w-8 text-primary" />,
    action: "Criar Imagens",
    url: "https://vispunk.com/leonardo-ai"
  },
  {
    title: "RapidTags",
    description: "Gerador de tags para YouTube que ajuda a otimizar seus vídeos e aumentar a visibilidade.",
    icon: <FileText className="h-8 w-8 text-primary" />,
    action: "Gerar Tags",
    url: "https://rapidtags.io/generator"
  },
  {
    title: "MegaZone Downloads",
    description: "Portal com diversos conteúdos e downloads para complementar seus projetos.",
    icon: <FileArchive className="h-8 w-8 text-primary" />,
    action: "Acessar",
    url: "https://megazonedownloads.comunidades.net/"
  },
  {
    title: "YouTube Canal",
    description: "Inscreva-se no nosso canal do YouTube para acompanhar todos os nossos conteúdos e novidades.",
    icon: <Video className="h-8 w-8 text-primary" />,
    action: "Inscrever-se",
    url: "https://studio.youtube.com/channel/UC-20RsfqftBP6yKfOUHEdsA"
  },
  {
    title: "YouTube Live",
    description: "Assista nossa live completa com os melhores conteúdos e não perca nenhuma novidade.",
    icon: <Video className="h-8 w-8 text-primary" />,
    action: "Assistir Live",
    url: "https://www.youtube.com/live/B1CdO1-2asA"
  },
  {
    title: "Canva",
    description: "Crie designs profissionais, apresentações, posts para redes sociais e muito mais com facilidade.",
    icon: <PenTool className="h-8 w-8 text-primary" />,
    action: "Acessar Canva",
    url: "https://www.canva.com/join/dvz-wgh-khp"
  },
  {
    title: "ChatGPT",
    description: "Gere textos para suas legendas, crie histórias e obtenha ideias criativas para seus conteúdos.",
    icon: <MessageSquare className="h-8 w-8 text-primary" />,
    action: "Criar Texto"
  },
  {
    title: "Deep AI",
    description: "Transforme suas ideias em imagens impressionantes usando inteligência artificial avançada.",
    icon: <Image className="h-8 w-8 text-primary" />,
    action: "Gerar Imagem"
  },
  {
    title: "Clideo",
    description: "Edite seus vídeos facilmente, adicione efeitos, textos e transformações profissionais.",
    icon: <Edit className="h-8 w-8 text-primary" />,
    action: "Editar Vídeo"
  },
  {
    title: "CapCut",
    description: "Crie vídeos profissionais com uma ferramenta completa de edição para todas as plataformas.",
    icon: <Video className="h-8 w-8 text-primary" />,
    action: "Montar Vídeo"
  },
  {
    title: "Suno AI",
    description: "Gere músicas originais para seus vídeos usando inteligência artificial de ponta.",
    icon: <Music className="h-8 w-8 text-primary" />,
    action: "Criar Música"
  },
  {
    title: "Rumble",
    description: "Compartilhe seus vídeos na plataforma Rumble e comece a construir sua audiência.",
    icon: <Share2 className="h-8 w-8 text-primary" />,
    action: "Publicar",
    url: "https://rumble.com/register/FARIAS/"
  },
  {
    title: "Bitchute",
    description: "Plataforma alternativa para compartilhar seus vídeos sem censura e monetizar seu conteúdo.",
    icon: <Video className="h-8 w-8 text-primary" />,
    action: "Acessar Canal",
    url: "https://old.bitchute.com/channel/jGs5mLAXFlSu/"
  },
  {
    title: "Bitchute Referral",
    description: "Crie sua conta na Bitchute através do nosso link de referência e comece a publicar.",
    icon: <Share2 className="h-8 w-8 text-primary" />,
    action: "Criar Conta",
    url: "https://www.bitchute.com/accounts/referral/killer45/"
  },
  {
    title: "Clipto Downloader",
    description: "Baixe vídeos do YouTube facilmente para usar em seus projetos e edições.",
    icon: <FileArchive className="h-8 w-8 text-primary" />,
    action: "Baixar Vídeos",
    url: "https://www.clipto.com/pt/media-downloader/youtube-downloader"
  },
  {
    title: "Adobe Express",
    description: "Crie designs profissionais, edite imagens e produza conteúdo visual de alta qualidade.",
    icon: <PenTool className="h-8 w-8 text-primary" />,
    action: "Design Rápido"
  },
  {
    title: "TTS Free",
    description: "Converta texto em áudio natural com diversas vozes e idiomas para seus projetos.",
    icon: <Mic className="h-8 w-8 text-primary" />,
    action: "Gerar Áudio"
  },
  {
    title: "Powtoon",
    description: "Crie animações e vídeos explicativos profissionais com facilidade para engajar seu público.",
    icon: <Video className="h-8 w-8 text-primary" />,
    action: "Criar Animação"
  },
  {
    title: "4shared",
    description: "Armazene e compartilhe seus arquivos grandes com segurança e facilidade.",
    icon: <FileArchive className="h-8 w-8 text-primary" />,
    action: "Compartilhar"
  },
  {
    title: "Blogger",
    description: "Crie e gerencie seu blog gratuitamente, compartilhando conteúdo com seu público.",
    icon: <Globe className="h-8 w-8 text-primary" />,
    action: "Acessar Blog",
    url: "https://livrariagokage.blogspot.com/2025/04/100-contos-de-terror.html"
  }
];

const ToolsSection = () => {
  return (
    <section id="tools" className="py-20 bg-gradient-to-b from-background/90 to-background px-4 sm:px-6 lg:px-8 relative">
      {/* Background elements */}
      <div className="absolute w-96 h-96 bg-accent/5 rounded-full blur-3xl top-40 -left-48"></div>
      
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            viewport={{ once: true }}
          >
            <h2 className="text-3xl sm:text-4xl font-bold text-foreground mb-4">
              Ferramentas Poderosas
            </h2>
            <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
              Tudo o que você precisa para criar conteúdo incrível em um só lugar
            </p>
          </motion.div>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8">
          {tools.map((tool, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              viewport={{ once: true }}
            >
              <Card className="bg-card border-border h-full hover:border-primary/50 transition-colors">
                <CardHeader>
                  <div className="mb-2">
                    {tool.icon}
                  </div>
                  <CardTitle className="text-card-foreground">{tool.title}</CardTitle>
                </CardHeader>
                <CardContent className="space-y-4">
                  <p className="text-muted-foreground">{tool.description}</p>
                  <Button 
                    onClick={() => {
                      if (tool.url) {
                        window.open(tool.url, '_blank');
                      } else {
                        toast.info(`${tool.title} estará disponível em breve!`);
                      }
                    }}
                    className="w-full bg-secondary hover:bg-secondary/80 text-secondary-foreground"
                  >
                    {tool.action}
                  </Button>
                </CardContent>
              </Card>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ToolsSection;